const normalize = text => text.replace(/\s+/g, ' ').trim();
const BLOCKED = 'script,style,input,textarea,select,option,iframe,object,embed,template,noscript,[contenteditable],[hidden],[aria-hidden="true"]';

// Edit the original source, never the running preview or its injected bridge.
function resolveText(html, selection) {
  if (selection?.kind !== 'element' || selection.elements?.length !== 1) return null;
  const target = selection.elements[0];
  try {
    const document = new DOMParser().parseFromString(html, 'text/html');
    const matches = document.querySelectorAll(target.selector);
    if (matches.length !== 1) return null;
    const element = matches[0];
    if (element.localName !== target.tag || element.closest(BLOCKED) || element.children.length || !element.textContent.trim() || element.textContent.length > 8000) return null;
    if (normalize(element.textContent).slice(0, 600) !== target.text) return null;
    return { document, element };
  } catch { return null; }
}

export function selectedHtmlText(html, selection) {
  return resolveText(html, selection)?.element.textContent ?? null;
}

export function replaceHtmlText(html, selection, text) {
  const resolved = resolveText(html, selection);
  if (!resolved || typeof text !== 'string' || text.length > 8000) throw new Error('Select a single piece of text from the original page to edit.');
  resolved.element.textContent = text;
  const doctype = html.match(/<!doctype\s[^>]*>/i)?.[0] || '';
  return `${doctype}${doctype ? '\n' : ''}${resolved.document.documentElement.outerHTML}`;
}
